import styled from "@emotion/styled";

const PageStyles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90vh;
  background-color: #f9f9f9;
  text-align: center;
  padding: 20px;
`;

const ImageStyles = styled.img`
  max-width: 400px;
  width: 120px;
  height: 80px;
  margin-bottom: 10px;
`;

const HeadingStyles = styled.h1`
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
`;

const ParagraphStyles = styled.p`
  font-size: 1rem;
  color: #666;
  margin-bottom: 20px;
`;

const SC = {
  PageStyles,
  ImageStyles,
  HeadingStyles,
  ParagraphStyles,
};

export default SC;
